import { Grid, GridItem, Heading } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import React from "react";
import {
  selectLoanProduct,
  selectLoanPurpose,
  selectPropertyType,
  selectStates,
} from "../../lib/models/short-term/short-term-form-selects.model";
import { FixAndFlipForm } from "../../lib/models/short-term/short-term-form.model";
import FormSectionHeader from "../common-quote/FormSectionHeader";
import SelectField from "../form-fields/SelectField";
import TextInputField from "../form-fields/TextInputField";

function LoanSummaryForm() {
  const { values } = useFormikContext<FixAndFlipForm>();
  const { loanProduct } = values;

  return (
    <Grid
      templateColumns="repeat(12, minmax(0, 1fr))"
      gap={{ base: 6, md: 8, lg: 8 }}
    >
      <GridItem colSpan={12}>
        <FormSectionHeader id="loan-summary" label="Loan Summary" />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 12 }}>
        <TextInputField label="Quote Name" name="quoteName" />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <SelectField
          label="Loan Product"
          name="loanProduct"
          data={selectLoanProduct}
          placeholder="Select a product"
        />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <SelectField
          label="Loan Purpose"
          name="loanPurpose"
          data={selectLoanPurpose}
          placeholder="Select a purpose"
        />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 12 }}>
        <Heading fontWeight="500" size="sm" as="h6">
          Property Address
        </Heading>
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <SelectField
          label="Property Type"
          name="propertyType"
          data={
            loanProduct === "BridgePlus"
              ? selectPropertyType.slice(0, -1)
              : selectPropertyType
          }
          placeholder="Select a property type"
        />
      </GridItem>

      <GridItem
        display={{ base: "none", lg: "grid" }}
        colSpan={{ base: 12, lg: 6 }}
      ></GridItem>

      <GridItem colSpan={{ base: 12, lg: 12 }}>
        <TextInputField label="Street Address" name="propertyAddress" />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <TextInputField label="City" name="city" />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 3 }}>
        <SelectField
          label="State"
          name="state"
          data={selectStates}
          placeholder="Select a state"
        />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 3 }}>
        <TextInputField
          label="Zipcode"
          name="zip"
          type="number"
          formatNumber
          formatOptions={{
            format: "#####",
            thousandSeparator: false,
            allowLeadingZeros: true,
          }}
        />
      </GridItem>
    </Grid>
  );
}

export default LoanSummaryForm;
